import { PERSON_STATUS_CODE } from 'constants/person';
import { SupplierGroupType } from 'util/transform/supplierGroup';

//
// --- Types ---

/**
 * PersonType interface is a modal of a logged in person data object. Some references to people
 * in this file may refer to TreeNode objects fo people (for bid events for example). Those people
 * tree node types have not been created yet.
 */

// cSpell:disable
export interface PersonType {
  active: boolean;
  addresskey: number;
  admincomments: string | null;
  admincompanykey: number;
  businesstitle: string;
  buyer: boolean;
  cellphone: string | null;
  companykey: number;
  contact: boolean;
  creationtime: string; // string in format YYYY-MM-DD
  domainObjectDescrKey: number;
  domainObjectKey: number;
  emailaddress: string;
  emailfrequency: string | null;
  employeeid: string | null;
  employeeid1: string | null;
  faxphone: string | null;
  firstname: string;
  forgotpasswordlinkid: string | null;
  freefield1: string | null;
  freefield2: string | null;
  freefield3: string | null;
  freefield4: string | null;
  freefield5: string | null;
  homedataset: string;
  inactive: boolean;
  inInvitableStatus: boolean;
  invited: boolean;
  lastloginattempt: number;
  lastname: string;
  locale: string;
  loginattempts: number;
  loginexpirationtime: string | null;
  loginhomepage: string;
  mailstop: string | null;
  middlename: string | null;
  passwordlastupdate: number; // timestamp
  passwordresetflag: string | null;
  pending: boolean;
  personkey: number;
  personstatuscode: string;
  preferredTimezone: string;
  receivemessagenotification: string;
  referredby: string;
  referredbybidevent: string | null;
  referredbycompany: string | null;
  referredbyleadcompanykey: string | null;
  referredbyofferingkey: string | null;
  registrationclientkey: string | null;
  roledescrkey: number;
  salutation: string;
  supplier: boolean;
  suspended: boolean;
  switchable: boolean;
  timezone: string | null;
  updatedbyuserkey: number;
  updatesearchindex: string | null;
  updatetime: string; // string in format YYYY-MM-DD
  userflag: string;
  username: string;
  workphone: string | null;
}
// cSpell:enable

//
// --- Person Name ---

export function combineFirstAndLastName(firstName?: string, lastName?: string) {
  const first = typeof firstName === 'string' ? firstName.trim() : '';
  const last = typeof lastName === 'string' ? lastName.trim() : '';

  return [first, last].filter(v => v).join(' ');
}

//
// --- Bid Event People Utils ---

export function canAddPersonToBidEvent(person: any, bidTeams: ReadonlyArray<any>) {
  return !isPersonOnBidEvent(person, bidTeams);
}

export function canAddPersonToPortal(person: any, supplierGroups: ReadonlyArray<SupplierGroupType>) {
  return !isPersonOnPortal(person, supplierGroups);
}

export function isPersonOnBidEvent(person: any, bidTeams: ReadonlyArray<any>) {
  if (!person || !person.personKey || !Array.isArray(bidTeams) || !bidTeams.length) {
    return false;
  }

  const personKey = parseInt(person.personKey, 10);
  return bidTeams.some(bidTeam =>
    bidTeam.bidTeamPersonKeys.map((bidTeamPersonKey: string) => parseInt(bidTeamPersonKey, 10)).includes(personKey)
  );
}

export function isPersonOnPortal(person: any, supplierGroups: ReadonlyArray<SupplierGroupType>) {
  if (!person || !person.personKey || !Array.isArray(supplierGroups) || !supplierGroups.length) {
    return false;
  }

  const personKey = parseInt(person.personKey, 10);
  return supplierGroups.some((supplierGroup: SupplierGroupType) =>
    supplierGroup.supplierPortalSupplierUserPersonKeys
      .map((supplierGroupPersonKey: unknown) => parseInt(supplierGroupPersonKey as string, 10))
      .includes(personKey)
  );
}

export function hasPersonAccessedBidEvent(person: any) {
  if (!person) {
    return false;
  }

  return person.personStatusCode === PERSON_STATUS_CODE.ACTIVE && !!person.invitedTime && !!person.lastViewTime;
}
